var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffa510;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Website_Development",
    "data-name": "Website Development"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,10A10,10,0,0,1,10,0H40A10,10,0,0,1,50,10V40A10,10,0,0,1,40,50H10A10,10,0,0,1,0,40Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path21599-4",
    className: "cls-2",
    d: "M14.55,8.51a1.66,1.66,0,0,0-1.65,1.64V12.9H37.09V10.15a1.65,1.65,0,0,0-1.64-1.64Zm1.1,2.19a.55.55,0,0,1,0,1.1.53.53,0,0,1-.54-.55A.55.55,0,0,1,15.65,10.7Zm2.2,0a.55.55,0,0,1,.55.55.55.55,0,1,1-.55-.55Zm2.2,0a.55.55,0,0,1,.55.55.55.55,0,1,1-.55-.55Zm7.67,0h6.63a.55.55,0,0,1,0,1.1h-6.6a.55.55,0,0,1,0-1.1ZM10.15,11.8a1.66,1.66,0,0,0-1.64,1.65v19.8a1.65,1.65,0,0,0,1.64,1.64H39.84a1.65,1.65,0,0,0,1.65-1.64V13.45a1.66,1.66,0,0,0-1.65-1.65H38.19v1.1h1.65a.54.54,0,0,1,.55.55v16H9.6V13.45a.54.54,0,0,1,.55-.55h1.66V11.8ZM12.9,14V28.3H37.09V14Zm13.76,2.2a.54.54,0,0,1,.51.73l-3.3,9.9a.55.55,0,0,1-1-.35l3.3-9.9A.53.53,0,0,1,26.66,16.2Zm3.09,2.33,3.3,2.75a.56.56,0,0,1,0,.85l-3.3,2.74a.55.55,0,1,1-.7-.84l2.79-2.33-2.79-2.33a.54.54,0,0,1,.32-1,.58.58,0,0,1,.38.13Zm-9.16-.13a.55.55,0,0,1,.36,1L18.16,21.7,21,24a.55.55,0,1,1-.7.84L17,22.13a.56.56,0,0,1,0-.85l3.3-2.75a.53.53,0,0,1,.34-.13ZM26.1,31.6a.55.55,0,0,1,0,1.1H23.9a.55.55,0,1,1,0-1.1ZM21.51,36a4.38,4.38,0,0,1-.6,1.11h8.18a4.38,4.38,0,0,1-.6-1.11ZM19,38.19a1.66,1.66,0,0,0-1.65,1.65v1.1a.55.55,0,0,0,.55.55h14.3a.53.53,0,0,0,.54-.55v-1.1a1.66,1.66,0,0,0-1.64-1.65Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteDevelopment);
export default __webpack_public_path__ + "static/media/Website-Development.15404960f994978cb3ceb16cb7598d41.svg";
export { ForwardRef as ReactComponent };